/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "tapestryGeo",
            "endpoint": "https://ss7me6aod7.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:690e44e9-3bd7-4b93-88bb-b36bbbe29867",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_npwaLtqHG",
    "aws_user_pools_web_client_id": "6l2m8drtnb9hjvlfpat5a5h3bv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tapestrytoolscb44991529474a8dabcac9a3d998551c185632-staging",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
